<template>
  <div>
    <div id="dashboard">
      <v-container>
        <v-row>
          <v-col>
            <v-card max-width="500px" elevation="10" shaped :items="this.wizardItems" item-key="wizardcode">
              <div class="ma-4">
                <br />
                <v-row align="center" justify="space-around">
                  <v-btn width="400px" class="primary" v-on:click="loadPage()">
                    {{ $t('dashboard.guide') }}
                  </v-btn>
                </v-row>
                <br />
                <v-row>
                  <v-col cols="4" sm="4" md="12" class="pb-n5">
                    <v-card-actions class="blue--text" style="font-size: 13px" v-for="item in wizardItems"
                      :key="item.id" v-on:click="loadPageHandler(item.id)">
                      {{ item.wizardcode }}
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>

          <v-col>
            <v-card max-width="500px" elevation="10" shaped :items="this.alertItems" item-key="alerttype">
              <div class="ma-4">
                <br />
                <v-row align="center" justify="space-around">
                  <v-btn width="400px" class="purple lighten-3" v-on:click="loadAlert()">
                    {{ $t('alert') }}
                  </v-btn>
                </v-row>
                <br />
                <v-row>
                  <v-col cols="4" sm="4" md="12" class="pb-n5">
                    <v-card-actions class="purple--text" style="font-size: 13px" v-for="item in alertItems"
                      :key="item.id" v-on:click="loadAlertHandler(item.id)">
                      ({{ item.length }}) {{ item.alerttype }}

                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div v-if="isErr">
        <app-error v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }" v-on:closeError="isErr = $event" />
      </div>

      <!-- Overlay -->
      <div v-if="showOverlay" class="overlay">
        <div class="overlay-content">
          <h2 class="pb-3">{{ acknowledgement.longdesc }}</h2>
          <h4 class="pb-3"> Published on: {{ acknowledgement.publishDate }} </h4>
          <div class="terms-scroll">
            <div v-html="acknowledgement.content"></div>
          </div>
          <div class="button-row">
            <button class="ack-btn" @click="acceptAcknowledge">Acknowledge</button>
            <button class="cancel-btn" @click="logoutHandler">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../../components/common/ErrorDialog";
import moment from "moment";

export default {
  components: {
    "app-error": ErrorDialog,
  },
  data() {
    return {
      getid: this.$route.params.id,
      getpanel: this.$route.params.panel,
      formData: {
        wizardcode: null,
        wizarddesc: null,
        alerttype: null,
        alerttypeid: null,
        length: null,
        userid: this.$store.getters.userId,
      },

      wizardItems: [],
      alertItems: [],

      dataItemsDueconfirm: [],
      dataItemsExtendedDueconfirm: [],
      dataItemsDuecessation: [],
      dataItemsDuecontract: [],
      dataItemsDuedocument: [],
      dataItemsDuebirthday: [],
      dataItemsDuework3years: [],
      dataItemsDuework5years: [],
      dataItemsDuework10years: [],

      isErr: false,
      errMsg: "",

      // Acknowledgement 
      showOverlay: false,
      acknowledgement: {
        id: null,
        longdesc: null,
        content: null,
        publishDate: null,
      },

      acknowledgementAcceptance: {  //new acknowledgement acceptance record
        ackRecordId: null,
        staffId: null,
        companyId: null,
        psnId: this.$store.getters.psnId,
        userId: this.$store.getters.userId,
        acknowledgementDateTime: null,
        stamp: 0,
        updatedby: this.$store.getters.userId
      },
    };
  },
  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadWizardList() {
      const vm = this;

      this.$store.dispatch('get', {
        url: "/wizardsetup/all"
      })
        .then((res) => {
          vm.wizardItems = res.data.rec;
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

    loadPageHandler(id) {
      let wizard = this.getid;
      this.$router.push({ name: "wizardstep", params: { id, wizard } });
    },

    getDueconfirmdateHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/dueconfirmdate/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDueconfirm = res.data.rec;

          vm.alertItems.push({
            id: 1,
            alerttype: this.$t('reporalertlisting.dueforconfirmationdate'),
            length: res.data.rec.length,
          });
          this.getExtendedDueconfirmdateHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getExtendedDueconfirmdateHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/exdueconfirmdate/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsExtendedDueconfirm = res.data.rec;

          vm.alertItems.push({
            id: 2,
            alerttype: this.$t('reporalertlisting.dueextendedconfirmationdate'),
            length: res.data.rec.length,
          });
          this.getDuecessationdateHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuecessationdateHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duecessationdate/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuecessation = res.data.rec;

          vm.alertItems.push({
            id: 3,
            alerttype: this.$t('reporalertlisting.dueforcessationdate'),
            length: res.data.rec.length,
          });
          this.getDuecontractexpiryHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuecontractexpiryHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duecontractexpiry/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuecontract = res.data.rec;

          vm.alertItems.push({
            id: 4,
            alerttype: this.$t('reporalertlisting.dueforcontractexpiry'),
            length: res.data.rec.length,
          });
          this.getDuedocumentexpiryHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuedocumentexpiryHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duedocumentexpiry/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuedocument = res.data.rec;

          vm.alertItems.push({
            id: 5,
            alerttype: this.$t('reporalertlisting.duefordocexpiry'),
            length: res.data.rec.length,
          });
          this.getDuebirthdayHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuebirthdayHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duebirthday/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuebirthday = res.data.rec;

          vm.alertItems.push({
            id: 6,
            alerttype: this.$t('reporalertlisting.duefordob'),
            length: res.data.rec.length,
          });
          this.getDuework3yearsHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuework3yearsHandler() {
      const vm = this;

      this.$store.dispatch('get', {
        url: `/duework3years/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuework3years = res.data.rec;

          vm.alertItems.push({
            id: 7,
            alerttype: this.$t('reporalertlisting.dueforwanthree'),
            length: res.data.rec.length,
          });
          this.getDuework5yearsHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuework5yearsHandler() {
      const vm = this;

      this.$store.dispatch('get', {
        url: `/duework5years/all/${this.$store.getters.userId}`
      })

        .then((res) => {
          vm.dataItemsDuework5years = res.data.rec;

          vm.alertItems.push({
            id: 8,
            alerttype: this.$t('reporalertlisting.dueforwanfive'),
            length: res.data.rec.length,
          });
          this.getDuework10yearsHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuework10yearsHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duework10years/all/${this.$store.getters.userId}`
      })

        .then((res) => {
          vm.dataItemsDuework10years = res.data.rec;

          vm.alertItems.push({
            id: 9,
            alerttype: this.$t('reporalertlisting.dueforwanten'),
            length: res.data.rec.length,
          });

          console.log("alert8", vm.alertItems);
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    loadAlertHandler(panel) {
      let alert = this.getpanel;
      this.$router.push({ name: "alertlisting", params: { panel, alert } });
    },

    loadPage() {
      this.$router.push({ name: "wizardlisting" });
    },

    loadAlert() {
      this.$router.push({ name: "alertlisting" });
    },

    Loadacknowledgement() {
      this.$store.dispatch('get', {
        url: `/validAcknowledgement/${this.$store.getters.psnId}/${this.$store.getters.userId}`
      })
        .then((res) => {
          // console.log("ack", res.data.rec);
          // console.log("what is the res result", res.data, "Full res", res);

          // i should reconsider here for res.status thing
          if (res.data.status == 500 || res.data.status == 404) {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
          else if (res.data.status == 200) {
            // Show Acknowledgement Overlay
            this.acknowledgement.id = res.data.rec.acknowledgement.id;
            this.acknowledgement.longdesc = res.data.rec.acknowledgement.ackLongDesc;
            this.acknowledgement.content = res.data.rec.acknowledgement.content;
            this.acknowledgement.publishDate = moment(res.data.rec.acknowledgement.publishDate).format("DD MMMM YYYY");
            // console.log("acknowledgement value", this.acknowledgement);

            //prepare new acknowledgement acceptance record, to save later
            this.acknowledgementAcceptance.ackRecordId = res.data.rec.acknowledgement.id;
            this.acknowledgementAcceptance.staffId = res.data.rec.staffId;
            this.acknowledgementAcceptance.companyId = res.data.rec.companyId;

            this.showOverlay = true;
          }
          else if (res.data.status == 204) {
            // No pending acknowledgement to show
            // console.log("No pending acknowledgement to show");
          }
          else {
            this.isErr = true;
            this.errMsg = "Unexpected response status while loading Acknowledgement: " + res.data.status;
            console.log("Unexpected response:", res.data);
          }
        })
        .catch((err) => {
          this.isErr = true;
          this.errMsg = err;
        });
    },

    acceptAcknowledge() {
      console.log("Acknowledge button clicked");
      console.log("now pass the acknowledgementAcceptance data", this.acknowledgementAcceptance);
      const vm = this;
      this.$store.dispatch('post', { url: "/acknowledgementacceptance/new", payload: this.acknowledgementAcceptance })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            // const id = res.data.newInsertedId;
            // this.$router.push({ name: "acknowledgementedit", params: { id: id } });
            this.showOverlay = false;
            window.location.reload(); //reload page if there is another acknowledgement to show
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

    logoutHandler() {
      this.$router.replace("/" + this.$i18n.locale + "/home/" + this.$store.getters.db);
      this.$store.dispatch("deleteToken");
    },
  },

  mounted() {
    this.loadWizardList();

    this.getDueconfirmdateHandler();

    //console.log("staffid,", this.$store.getters.staffId, "and userid,", this.$store.getters.userId, "psnid", this.$store.getters.psnId);
    if (this.$store.getters.psnId) { // valid psnId
      this.Loadacknowledgement();
    }
    else {
      console.log("No valid psnId to load Acknowledgement");
    }
  },
};
</script>

<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.overlay-content {
  background: white;
  width: 80%;
  height: 80%;
  max-height: 80%;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.terms-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fafafa;
  line-height: 1.6;
  color: #333;
}

.ack-btn {
  align-self: center;
  padding: 12px 28px;
  background-color: #28a745;
  /* Green */
  color: white;
  font-weight: 600;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.ack-btn:hover {
  background-color: #218838;
  /* Darker green on hover */
  transform: translateY(-1px);
}

.ack-btn:active {
  background-color: #1e7e34;
  /* Even darker when pressed */
  transform: translateY(1px);
}

.button-row {
  display: flex;
  justify-content: center;
  /* center horizontally */
  gap: 20px;
  /* space between buttons */
  margin-top: 20px;
}

.cancel-btn {
  padding: 12px 28px;
  background-color: #ffc107;
  /* Bootstrap warning color */
  color: #ffffff;
  /* dark text for contrast */
  font-weight: 600;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.cancel-btn:hover {
  background-color: #e0a800;
  /* darker warning on hover */
  transform: translateY(-1px);
}

.cancel-btn:active {
  background-color: #d39e00;
  /* even darker when pressed */
  transform: translateY(1px);
}
</style>
